import React, { useState, useEffect } from "react";

import {
  Box,
  TextField,
  Typography,
  MenuItem,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  FormControlLabel,
  Button,
  Stack,
  RadioGroup,
  Radio,
  FormControl,
  InputLabel,
  Alert,
} from "@mui/material";

import Snackbar from "@mui/material/Snackbar";
import { useClientInfo, axiosInstance } from "../../utils/commonImports";
import InputAdornment from "@mui/material/InputAdornment";
import MyDatePicker from "../../components/MyDatePicker";
import VendorDropdown from "../../components/VendorDropdown";
import VehicleDropdown from "../../components/VehicleDropdown";

import { createDocument } from "../../api/numberingApi";
import { useParams } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";

import PreviewModal from "../../components/preview/PreviewModal";

import { numberToIndianWords } from "../../utils/numberToIndianWords";
import { normalizeDateAny } from "../../utils/dateUtils";

// ================= GST Calculation Function =================
function calculateGstAmounts({
  tax_preference,
  place_of_supply,
  client_place_of_supply,
  taxable_amount,
  cgst_percent = 0,
  sgst_percent = 0,
  igst_percent = 0,
}) {
  let cgst = 0;
  let sgst = 0;
  let igst = 0;

  if (tax_preference === "Taxable") {
    if (place_of_supply === client_place_of_supply) {
      cgst = (taxable_amount * cgst_percent) / 100;
      sgst = (taxable_amount * sgst_percent) / 100;
    } else {
      igst = (taxable_amount * igst_percent) / 100;
    }
  }

  return { cgst, sgst, igst };
}

// export default function PurchaseFormAdd({ purchaseId }) {
export default function PurchaseFormAdd({
  purchaseType = "vendor", // vendor | vehicle
  purchaseId,
  editData,
  onCancel,
  onSuccess,
}) {
  const { clientId } = useClientInfo();
  const [clientDetails, setClientDetails] = useState({});
  const [filterType, setFilterType] = useState("all");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [vendors, setVendors] = useState([]);

  const [vehicles, setVehicles] = useState([]);

  const [tripDuties, setTripDuties] = useState([]);
  const [selectedIndices, setSelectedIndices] = useState([]);
  const [loadingTrips, setLoadingTrips] = useState(false);

  const [selectedVendor, setSelectedVendor] = useState("");

  const [rows, setRows] = useState([]);
  const [selectedAll, setSelectedAll] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState([]);
  const selectedRows = rows.filter((_, idx) => selectedIndex.includes(idx));

  const [form, setForm] = useState({
    purchaseid: "",
    number: "",
    date: "",
    reference: "",
    po_no: "",
    vendorid: 0,
    vendors: "",
    gst_treatment: "",
    tax_preference: "",
    vendorgstin: "",
    place_of_supply: "",
    cal_gst_parking_toll_permit: "",
    cal_gst_batta: "",
    cal_gst_others: "",
    payment_mode: "",
    client_place_of_supply: "",
    taxable_amount: 0,
    cgst_amount: 0,
    sgst_amount: 0,
    igst_amount: 0,
    gross_before_tax: 0,
    advance_amount: 0,
    voucher_advance_amount: 0,
    coin_adjust: 0,
    addition_amount: 0,
    discount_amount: 0,
    deduction_amount: 0,
    hsn_code: "996601",
    gst_notification: "",
    remarks: "",

    // any other fields you use...
  });

  const { purchaseParam } = useParams(); // URL param like /purchase/:purchaseParam
  const existingDutyIds =
    editData?.trip_duties?.map((duty) => duty.trip_duty_id) || [];

  const [purchaseNumber, setPurchaseNumber] = useState(form.number);

  const [basic_amount, setBasic_amount] = useState(0);
  const [fuel_esc_amount, setFuel_esc_amount] = useState(0);
  const [escort_amount, setEscort_amount] = useState(0);
  const [batta_amount, setBatta_amount] = useState(0);
  const [parking_amount, setParking_amount] = useState(0);
  const [toll_amount, setToll_amount] = useState(0);
  const [permit_amount, setPermit_amount] = useState(0);
  const [others_amount, setOthers_amount] = useState(0);
  const [clientBanks, setClientBanks] = useState([]);

  const [duties, setDuties] = useState([]);
  const [billedDuties, setBilledDuties] = useState([]); // duties already billed
  const [unbilledDuties, setUnbilledDuties] = useState([]); // pending duties
  const [selectedDutyIds, setSelectedDutyIds] = useState([]); // checked ids in popup
  const [showDutySelector, setShowDutySelector] = useState(false); // popup

  // Voucher states
  const [vouchers, setVouchers] = useState([]);
  const [selectedVoucherIds, setSelectedVoucherIds] = useState([]);
  const [voucherSelectAll, setVoucherSelectAll] = useState(false);
  const [showVoucherTable, setShowVoucherTable] = useState(false);

  const currentPurchaseId =
    purchaseId || form?.purchaseid || editData?.purchaseid;

  // Determine edit mode based on currentPurchaseId
  const isEditMode = Boolean(currentPurchaseId);

  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [previewHTML, setPreviewHTML] = useState("");

  console.log("MODE RAW VALUES:", {
    isEditMode,
    purchaseType,
    dbValue: form.is_vendor_purchase,
    dbType: typeof form.is_vendor_purchase,
  });

  const normalizedIsVendorPurchase = (() => {
    if (isEditMode) {
      if (form.is_vendor_purchase === true) return true;
      if (form.is_vendor_purchase === false) return false;

      if (form.is_vendor_purchase === "true") return true;
      if (form.is_vendor_purchase === "false") return false;

      if (form.is_vendor_purchase === 1) return true;
      if (form.is_vendor_purchase === 0) return false;

      return false; // fallback
    }

    return purchaseType === "vendor";
  })();

  const isVendorMode = normalizedIsVendorPurchase;
  const isVehicleMode = !normalizedIsVendorPurchase;

  // const [showPrintConfirm, setShowPrintConfirm] = useState(false);
  // let tempPurchaseIdRef = useRef(null);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    const selectedRows = rows.filter((_, idx) => selectedIndex.includes(idx));

    setBasic_amount(
      selectedRows.reduce(
        (acc, r) => acc + Number(r.trip_payouts_basic_amount || 0),
        0,
      ),
    );
    setFuel_esc_amount(
      selectedRows.reduce(
        (acc, r) => acc + Number(r.trip_payouts_fuel_esculation_amount || 0),
        0,
      ),
    );
    setEscort_amount(
      selectedRows.reduce(
        (acc, r) => acc + Number(r.trip_payouts_escort_amount || 0),
        0,
      ),
    );
    setBatta_amount(
      selectedRows.reduce(
        (acc, r) => acc + Number(r.trip_payouts_batta || 0),
        0,
      ),
    );
    setParking_amount(
      selectedRows.reduce(
        (acc, r) => acc + Number(r.trip_payouts_parking || 0),
        0,
      ),
    );
    setToll_amount(
      selectedRows.reduce(
        (acc, r) => acc + Number(r.trip_payouts_toll_fasttag || 0),
        0,
      ),
    );
    setPermit_amount(
      selectedRows.reduce(
        (acc, r) => acc + Number(r.trip_payouts_permit || 0),
        0,
      ),
    );
    setOthers_amount(
      selectedRows.reduce(
        (acc, r) => acc + Number(r.trip_payouts_others || 0),
        0,
      ),
    );
  }, [selectedIndex, rows]);

  // You should manage these states with hooks and input change handlers in real form
  const addition_amount = 0;
  const discount_amount = 0;
  const deduction_amount = 0;
  const hsn_code = "996601";
  const gst_notification = "";
  const remarks = "";

  // Assuming you have vendorData loaded e.g. from API or state
  const vendorData = {
    cal_gst_batta: "Yes", // or "No"
    cal_gst_others: "No",
    cal_gst_parking_toll_permit: "Yes",
  };

  // Calculate Gross amount before tax (you may want to build this in logic)
  const gross_before_tax =
    basic_amount +
    fuel_esc_amount +
    escort_amount +
    batta_amount +
    parking_amount +
    toll_amount +
    permit_amount +
    others_amount +
    addition_amount -
    deduction_amount -
    discount_amount;

  const taxable_amount =
    basic_amount +
    fuel_esc_amount +
    escort_amount +
    (form.cal_gst_batta === "Yes" ? batta_amount : 0) +
    (form.cal_gst_parking_toll_permit === "Yes"
      ? parking_amount + toll_amount + permit_amount
      : 0) +
    (form.cal_gst_others === "Yes" ? others_amount : 0) +
    addition_amount -
    discount_amount -
    deduction_amount;

  const paymentModes = [
    "Company",
    "Immediate",
    "Credit",
    "Cash",
    "Online",
    "UPI",
  ];

  useEffect(() => {
    if (!clientId) return;

    async function fetchClientData() {
      console.log("Client id inside fetchClientData() :", clientId);

      try {
        const res = await axiosInstance.get(`/api/clients/${clientId}`);

        console.log("🔵 API Client Response:", res.data);

        const client = res.data.client;

        console.log("🟣 Extracted Client Object:", client);

        setClientDetails(client);

        setForm((prev) => ({
          ...prev,
          client_place_of_supply: client.place_of_supply || "",
        }));
      } catch (error) {
        console.error("❌ Failed to fetch client details:", error);
      }
    }

    fetchClientData();
  }, [clientId]);

  useEffect(() => {
    if (!clientId) return;
    async function fetchVendors() {
      try {
        const response = await axiosInstance.get("/api/vendors", {
          params: { client_id: clientId },
        });
        setVendors(response.data || []);
      } catch (error) {
        console.error("Error fetching vendors:", error);
        setVendors([]);
      }
    }
    fetchVendors();
  }, [clientId]);

  useEffect(() => {
    if (!clientId) return;

    async function fetchVehicles() {
      try {
        const response = await axiosInstance.get("/api/vehicles", {
          params: { client_id: clientId },
        });

        setVehicles(response.data || []);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        setVehicles([]);
      }
    }

    fetchVehicles();
  }, [clientId]);

  const [igstPercent, setIgstPercent] = useState(0);
  const [cgstPercent, setCgstPercent] = useState(0);
  const [sgstPercent, setSgstPercent] = useState(0);

  useEffect(() => {
    if (!clientId) return;

    async function fetchGSTSettings() {
      try {
        const res = await axiosInstance.get(
          `/api/clients/${clientId}/gst-settings`,
        );

        const gst = res.data?.gst || {};

        // Sync GST percent values
        setCgstPercent(gst.tax_rate_cgst || 0);
        setSgstPercent(gst.tax_rate_sgst || 0);
        setIgstPercent(gst.tax_rate_igst || 0);

        // Sync into form for NEW purchase
        if (!isEditMode) {
          setForm((prev) => ({
            ...prev,
            cgst_percent: gst.tax_rate_cgst || 0,
            sgst_percent: gst.tax_rate_sgst || 0,
            igst_percent: gst.tax_rate_igst || 0,
            hsn_code: gst.hsn_code || "",
            gst_notification: gst.gst_notification || "",
          }));
        }
      } catch (error) {
        console.error("Error fetching GST settings:", error);
      }
    }

    fetchGSTSettings();
  }, [clientId]);

  useEffect(() => {
    const { cgst, sgst, igst } = calculateGstAmounts({
      tax_preference: form.tax_preference,
      place_of_supply: form.place_of_supply,
      client_place_of_supply: form.client_place_of_supply,
      taxable_amount: Number(taxable_amount) || 0,
      cgst_percent: Number(form.cgst_percent) || 0,
      sgst_percent: Number(form.sgst_percent) || 0,
      igst_percent: Number(form.igst_percent) || 0,
    });

    setForm((prev) => ({
      ...prev,
      cgst_amount: cgst,
      sgst_amount: sgst,
      igst_amount: igst,
      taxable_amount,
    }));
  }, [
    taxable_amount,
    form.tax_preference,
    form.place_of_supply,
    form.client_place_of_supply,
    form.cgst_percent,
    form.sgst_percent,
    form.igst_percent,
  ]);

  // 1. Keep discount_amount synced with discount_percent & basic_amount
  useEffect(() => {
    const discountPercent = Number(form.discount_percent) || 0;
    const discountAmount = (basic_amount * discountPercent) / 100;
    if (discountAmount !== form.discount_amount) {
      setForm((prev) => ({ ...prev, discount_amount: discountAmount }));
    }
  }, [form.discount_percent, basic_amount]);

  // 2. Recalculate gross_before_tax and taxable_amount anytime amounts change
  useEffect(() => {
    const gross_before_tax =
      Number(basic_amount) +
      Number(fuel_esc_amount) +
      Number(escort_amount) +
      Number(batta_amount) +
      Number(parking_amount) +
      Number(toll_amount) +
      Number(permit_amount) +
      Number(others_amount) +
      Number(form.addition_amount || 0) -
      Number(form.deduction_amount || 0) -
      Number(form.discount_amount || 0);

    const taxable_amount =
      Number(basic_amount) +
      Number(fuel_esc_amount) +
      Number(escort_amount) +
      (form.cal_gst_batta === "Yes" ? Number(batta_amount) : 0) +
      (form.cal_gst_parking_toll_permit === "Yes"
        ? Number(parking_amount) + Number(toll_amount) + Number(permit_amount)
        : 0) +
      (form.cal_gst_others === "Yes" ? Number(others_amount) : 0) +
      Number(form.addition_amount || 0) -
      Number(form.deduction_amount || 0) -
      Number(form.discount_amount || 0);

    setForm((prev) => ({
      ...prev,
      gross_before_tax,
      taxable_amount,
    }));
  }, [
    basic_amount,
    fuel_esc_amount,
    escort_amount,
    batta_amount,
    parking_amount,
    toll_amount,
    permit_amount,
    others_amount,
    form.cal_gst_batta,
    form.cal_gst_parking_toll_permit,
    form.cal_gst_others,
    form.addition_amount,
    form.deduction_amount,
    form.discount_amount,
  ]);

  function roundCoinAdjust(value) {
    const integerPart = Math.floor(value);
    const fraction = value - integerPart;

    if (fraction < 0.5) {
      return integerPart; // round down to integer
    } else {
      return integerPart + 1; // round up to next integer
    }
  }

  useEffect(() => {
    const baseAmount =
      Number(form.gross_before_tax) +
      Number(form.cgst_amount) +
      Number(form.sgst_amount) +
      Number(form.igst_amount) -
      (Number(form.advance_amount) || 0) -
      (Number(form.voucher_advance_amount) || 0);

    if (baseAmount <= 0) return; // skip calculation

    // Calculate raw difference to round
    const difference = baseAmount - Math.floor(baseAmount);

    // Decide coin_adjust based on difference rounded by custom function
    const roundedAdjust = roundCoinAdjust(difference);

    // Calculate coin_adjust needed to bring baseAmount to an integer rounded as requested
    const newCoinAdjust = roundedAdjust - difference;

    setForm((prev) => ({ ...prev, coin_adjust: newCoinAdjust }));
  }, [
    form.gross_before_tax,
    form.cgst_amount,
    form.sgst_amount,
    form.igst_amount,
    form.advance_amount,
    form.voucher_advance_amount,
  ]);

  // Add to your state:
  const [netAmount, setNetAmount] = useState(0);

  useEffect(() => {
    let baseAmount = Number(form.gross_before_tax) || 0;

    const isRCM = form.gst_treatment === "Registered Business-Under RCM";

    // REGULAR GST → ADD GST AMOUNT
    if (!isRCM) {
      baseAmount +=
        Number(form.cgst_amount) +
        Number(form.sgst_amount) +
        Number(form.igst_amount);
    }

    // RCM → DO NOT ADD GST (GST only shown inside purchase)
    // baseAmount stays same

    // SUBTRACT ADVANCES
    baseAmount -=
      Number(form.advance_amount || 0) +
      Number(form.voucher_advance_amount || 0);

    // ADD COIN ADJUST
    baseAmount += Number(form.coin_adjust || 0);

    setNetAmount(baseAmount);
  }, [
    form.gross_before_tax,
    form.cgst_amount,
    form.sgst_amount,
    form.igst_amount,
    form.advance_amount,
    form.voucher_advance_amount,
    form.coin_adjust,
    form.gst_treatment,
  ]);

  // Effect to keep selectedDutyIds in sync with selectedIndex/selectedRows
  useEffect(() => {
    const ids = selectedIndex.map((i) => rows[i]?.trip_duty_id).filter(Boolean);
    setSelectedDutyIds(ids);
  }, [selectedIndex, rows]);

  useEffect(() => {
    console.log("🔥 Trip Effect Entered");

    const isEdit = Number(form.purchaseid) > 0;

    // ✅ Decide filter purely from data
    const filterId = form.vehicleid
      ? form.vehicleid
      : form.vendorid
        ? form.vendorid
        : null;

    console.log("TRIP FILTER STATE:", {
      isEdit,
      vendorid: form.vendorid,
      vehicleid: form.vehicleid,
      filterId,
      clientId,
    });

    if (!clientId || !filterId) {
      console.log("⛔ Blocked: clientId or filterId missing");
      return;
    }

    const fetchTripDuties = async () => {
      try {
        const purchaseParam = isEdit ? form.purchaseid : "new";

        const filterId = form.vehicleid ? form.vehicleid : form.vendorid;

        const res = await axiosInstance.get(
          `/api/purchases/${purchaseParam}/tripduties`,
          {
            params: {
              client_id: clientId,
              filter_id: filterId, // ✅ IMPORTANT
            },
          },
        );

        const selected = res.data?.selected || [];
        const pending = res.data?.pending || [];

        if (isEdit) {
          setRows(selected);
          setSelectedIndex(selected.map((_, i) => i));
        } else {
          const normalized = pending.map((d) => ({
            ...d,
            trip_duty_id: d.trip_duty_id || d.id,
          }));

          setRows(normalized);
          setSelectedIndex([]);
        }
      } catch (err) {
        console.error("Trip load error:", err);
        setRows([]);
        setSelectedIndex([]);
      }
    };

    fetchTripDuties();
  }, [form.vendorid, form.vehicleid, form.purchaseid, clientId]);

  useEffect(() => {
    async function loadBanks() {
      try {
        const response = await axiosInstance.get(
          `/api/client-banks/${clientId}`,
        );

        setClientBanks(response.data || []);
        console.log("BANKS LOADED:", response.data);
      } catch (err) {
        console.error("Failed to load client banks", err);
      }
    }

    loadBanks();
  }, [clientId]);

  useEffect(() => {
    if (!form.vendorid || !clientId) return;

    async function loadLedgerId() {
      try {
        console.log("🔍 Fetching Ledger ID for vendor:", form.vendorid);

        const res = await axiosInstance.get("/api/vendors/ledger-id", {
          params: { client_id: clientId, vendor_id: form.vendorid },
        });

        console.log("📌 Ledger ID received:", res.data.ledger_id);

        setForm((prev) => ({
          ...prev,
          vendor_ledger_id: res.data.ledger_id,
        }));
      } catch (err) {
        console.error("❌ Ledger Load Error:", err);
      }
    }

    loadLedgerId();
  }, [form.vendorid, clientId]);

  // inside your component
  useEffect(() => {
    if (showVoucherTable) return;
    if (!form.vendor_ledger_id || !clientId) return;

    async function loadVouchersForEdit() {
      try {
        console.log("📌 Loading vouchers for purchase form");

        // NEW purchase → only pending vouchers (same as before)
        if (!form.purchaseid) {
          const pendingRes = await axiosInstance.get("/api/vouchers/pending", {
            params: {
              client_id: clientId,
              ledger_id: form.vendor_ledger_id,
            },
          });

          const pending = pendingRes.data || [];
          // Normalize shape: ensure voucher_id present
          const normalizedPending = pending.map((p) => ({
            ...p,
            voucher_id: p.voucher_id || p.id,
          }));

          setVouchers(normalizedPending);
          setSelectedVoucherIds([]);
          setShowVoucherTable(Boolean(normalizedPending.length));
          return;
        }

        // EDIT purchase → load only selected initially
        const selectedRes = await axiosInstance.get("/api/vouchers/selected", {
          params: {
            client_id: clientId,
            purchase_id: form.purchaseid,
            vendor_id: form.vendor_ledger_id,
          },
        });

        const selected = selectedRes.data || [];
        const normalizedSelected = selected.map((s) => ({
          ...s,
          voucher_id: s.voucher_id || s.id,
        }));

        setVouchers(normalizedSelected);
        // Selected ids MUST be voucher_id
        setSelectedVoucherIds(normalizedSelected.map((v) => v.voucher_id));
        setShowVoucherTable(normalizedSelected.length > 0);
      } catch (err) {
        console.error("❌ Voucher Load Error:", err);
      }
    }

    loadVouchersForEdit();
  }, [form.vendor_ledger_id, form.purchaseid, clientId]);

  // -------------------------------
  // Select / Unselect Single Voucher
  // -------------------------------
  const handleVoucherSelect = (voucherId) => {
    const id = Number(voucherId);
    console.log("HANDLE CALL → id:", id);

    setSelectedVoucherIds((prev) => {
      const updated = prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id];

      console.log("STATE UPDATE REQUEST → updated:", updated);

      // ⭐ Update total immediately when selection changes
      updateVoucherTotal(updated);

      return updated;
    });
  };

  // -------------------------------
  // Select / Unselect ALL Vouchers
  // -------------------------------
  const handleVoucherSelectAll = () => {
    if (voucherSelectAll) {
      setVoucherSelectAll(false);
      setSelectedVoucherIds([]);
      updateVoucherTotal([]);
    } else {
      const allIds = vouchers
        .map((v) => parseInt(v.voucher_id || v.id, 10)) // ⭐ ensure integer
        .filter((n) => !isNaN(n));

      setVoucherSelectAll(true);
      setSelectedVoucherIds(allIds);
      updateVoucherTotal(allIds);
    }
  };

  const handleOpenVoucherTable = async () => {
    try {
      console.log("🟦 +Voucher clicked → loading pending + selected vouchers");

      if (!clientId || !form.vendor_ledger_id) {
        console.log("❌ Missing clientId or vendor_ledger_id");
        return;
      }

      // 1) Pending
      const pendingRes = await axiosInstance.get("/api/vouchers/pending", {
        params: {
          client_id: clientId,
          ledger_id: form.vendor_ledger_id,
        },
      });
      const pending = pendingRes.data || [];
      const normalizedPending = pending.map((p) => ({
        ...p,
        voucher_id: p.voucher_id || p.id,
      }));

      // 2) Selected (if edit)
      let selected = [];
      if (form.purchaseid) {
        const selectedRes = await axiosInstance.get("/api/vouchers/selected", {
          params: {
            client_id: clientId,
            purchase_id: form.purchaseid,
            vendor_id: form.vendor_ledger_id,
          },
        });
        selected = selectedRes.data || [];
      }
      const normalizedSelected = selected.map((s) => ({
        ...s,
        voucher_id: s.voucher_id || s.id,
      }));

      // 3) Merge: keep selected first, then pending (avoid duplicates by voucher_id)
      const selectedMap = new Map(
        normalizedSelected.map((s) => [s.voucher_id, s]),
      );
      normalizedPending.forEach((p) => {
        if (!selectedMap.has(p.voucher_id)) selectedMap.set(p.voucher_id, p);
      });

      const merged = Array.from(selectedMap.values());

      console.log("🟢 Final merged voucher list:", merged);

      setVouchers(merged);

      // Keep previously selected vouchers that are still present; otherwise only selected from API
      const currentlySelected =
        normalizedSelected.length > 0
          ? normalizedSelected.map((v) => v.voucher_id)
          : [];
      setSelectedVoucherIds(currentlySelected);

      setShowVoucherTable(true);
    } catch (err) {
      console.error("❌ Error loading voucher table:", err);
    }
  };

  // -------------------------------
  // Recalculate Total Advance
  // -------------------------------
  const updateVoucherTotal = (ids) => {
    const total = vouchers
      .filter((v) => ids.includes(v.voucher_id || v.id))
      .reduce((sum, v) => sum + Number(v.credit_amount || 0), 0);

    setForm((prev) => ({ ...prev, voucher_advance_amount: total }));
  };

  useEffect(() => {
    if (previewHTML) {
      setShowPreview(true);
    }
  }, [previewHTML]);

  const handleFilterChange = (e) => setFilterType(e.target.value);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectAll = (e) => {
    setSelectedAll(e.target.checked);
    setSelectedIndex(e.target.checked ? rows.map((_, idx) => idx) : []);
  };

  const handleSelectRow = (idx) => {
    if (selectedIndex.includes(idx)) {
      setSelectedIndex(selectedIndex.filter((i) => i !== idx));
    } else {
      setSelectedIndex([...selectedIndex, idx]);
    }
  };

  // --------------------
  // +DUTY POPUP HANDLERS
  // --------------------

  const handleAddDutyClick = async () => {
    try {
      console.log("🟦 +Duty clicked → loading pending + selected duties");

      const purchaseParam =
        form.purchaseid && form.purchaseid !== "0" ? form.purchaseid : "new";

      const res = await axiosInstance.get(
        `/api/purchases/${purchaseParam}/tripduties`,
        {
          params: {
            client_id: clientId,
            vendor_id: form.vendorid,
          },
        },
      );

      const billed = res.data.selected || [];
      const pending = res.data.pending || [];

      console.log("RAW Pending Response:", res.data.pending);
      console.log("📘 Billed:", billed);
      console.log("📙 Pending:", pending);

      // -----------------------------------------------------
      // NORMALIZE IDs + OPEN_DATE BEFORE USING IN TABLE
      // -----------------------------------------------------
      const normalizedBilled = billed.map((d) => ({
        ...d,
        trip_duty_id: d.trip_duty_id || d.id,
        open_date: normalizeDateAny(d.open_date),
      }));

      const normalizedPending = pending.map((d) => ({
        ...d,
        trip_duty_id: d.trip_duty_id || d.id,
        open_date: normalizeDateAny(d.open_date),
      }));

      // update originals
      setBilledDuties(normalizedBilled);
      setUnbilledDuties(normalizedPending);

      setSelectedDutyIds(normalizedBilled.map((d) => d.duty_id));

      // -----------------------------------------------------
      // MERGE & MAP TO FINAL TABLE ROWS
      // -----------------------------------------------------
      const merged = [...normalizedBilled, ...normalizedPending];

      // const mappedRows = merged.map((duty, index) =>
      //   mapTripDuty({
      //     ...duty,
      //     serial: index + 1,
      //     // open_date: normalizeDateAny(duty.open_date), // 🔥 final safeguard
      //   })
      // );

      console.log("🟢 FINAL TABLE ROWS:", merged);

      setRows(merged);

      setShowDutySelector(true);
    } catch (err) {
      console.log("❌ Error loading duties:", err);
    }
  };

  ///-------------- Saving Purchase Data to purchases Db -----------------
  useEffect(() => {
    if (editData) {
      console.log("EDIT DATA FULL:", editData);

      setForm({
        purchaseid: editData.purchaseid || editData.purchaseId || "", // Added purchaseid here
        client_id: editData.client_id || "",
        fyid: editData.fyid || "",
        bill_type: editData.bill_type || "",
        number: editData.purchase_number || "",
        date: editData.purchase_date ? new Date(editData.purchase_date) : null,
        vendorid: editData.vendor_id || "",
        vehicleid: editData.vehicle_id || "",
        is_vendor_purchase: editData.is_vendor_purchase,
        vehicle_number: editData.vehicle_number || editData.vehicle_no || "",
        reference: editData.reference || "",
        po_no: editData.po_no || "",
        payment_mode: editData.payment_mode || "",
        period_from: editData.period_from || null,
        period_to: editData.period_to || null,
        header: editData.header || "",
        basic_amount: Number(editData.basic_amount) || 0,
        escort_amount: Number(editData.escort_amount) || 0,
        batta_amount: Number(editData.batta_amount) || 0,
        parking_amount: Number(editData.parking_amount) || 0,
        others_amount: Number(editData.others_amount) || 0,
        permit_amount: Number(editData.permit_amount) || 0,
        toll_amount: Number(editData.toll_amount) || 0,
        fuel_ex_remarks: editData.fuel_ex_remarks || "",
        fuel_esc_amount: Number(editData.fuel_esc_amount) || 0,
        addition_remarks: editData.addition_remarks || "",
        addition_amount: Number(editData.addition_amount) || 0,
        deduction_remarks: editData.deduction_remarks || "",
        deduction_amount: Number(editData.deduction_amount) || 0,
        discount_percent: Number(editData.discount_percent) || 0,
        discount_amount: Number(editData.discount_amount) || 0,
        place_of_supply: editData.place_of_supply || "",
        tax_preference: editData.tax_preference || "",
        gst_treatment_id: editData.gst_treatment_id || null,
        gst_treatment: editData.gst_treatment || "",
        gst_notification: editData.gst_notification || "",
        hsn_code: editData.hsn_code || "",
        igst_percent: Number(editData.igst_percent) || 0,
        cgst_percent: Number(editData.cgst_percent) || 0,
        sgst_percent: Number(editData.sgst_percent) || 0,
        cal_gst_parking_toll_permit: editData.cal_gst_parking_toll_permit || "",
        cal_gst_batta: editData.cal_gst_batta || "",
        cal_gst_others: editData.cal_gst_others || "",
        igst_amount: Number(editData.igst_amount) || 0,
        cgst_amount: Number(editData.cgst_amount) || 0,
        sgst_amount: Number(editData.sgst_amount) || 0,
        advance_amount: Number(editData.advance_amount) || 0,
        voucher_advance_amount: Number(editData.voucher_advance_amount) || 0,
        coin_adjust: Number(editData.coin_adjust) || 0,
        net_amount: Number(editData.net_amount) || 0,
        word_amount: editData.word_amount || "",
        no_of_tripsheets: Number(editData.no_of_tripsheets) || 0,
        naration: editData.naration || "",
        annexureid: editData.annexureid || null,
        client_place_of_supply: editData.client_place_of_supply || "",
        // Add other fields as needed
      });
    }
  }, [editData]);

  console.log("EDIT DATA RAW:", editData);

  // ------------------------------------------------------
  // MAIN TRIP MAPPING FUNCTION (self-contained)
  // ------------------------------------------------------
  // function mapTripDuty(t) {
  //   function showDash(val) {
  //     if (val === null || val === undefined) return "-";
  //     if (val === "") return "-";
  //     if (isNaN(val)) return "-";
  //     return Number(val);
  //   }

  //   function showNumber(val) {
  //     return val && !isNaN(val) ? Number(val) : 0;
  //   }

  //   function showAmount(val) {
  //     const num = Number(val);
  //     return num > 0 ? num : "-";
  //   }

  //   function formatSlabDisplay(item) {
  //     const itemDuty = (item.duty || "").trim();

  //     if (itemDuty === "Outstation" || itemDuty === "OSDayRate") {
  //       const days = showNumber(item.trip_payouts_days_used);
  //       const minKm = showNumber(item.trip_payouts_slab_km);
  //       return days > 0 && minKm > 0 ? `${days} / ${days * minKm}` : "-";
  //     }

  //     const hours = showNumber(item.trip_payouts_slab_hour);
  //     const kms = showNumber(item.trip_payouts_slab_km);
  //     return hours > 0 || kms > 0 ? `${hours} / ${kms}` : "-";
  //   }

  //   // ---------------- BATTA ----------------
  //   let dutyVal = (t.duty || "").trim();

  //   // Local batta
  //   let batta_local =
  //     dutyVal === "Local" ? showNumber(t.trip_payouts_local_batta) : 0;

  //   // Outstation Day Batta
  //   let batta_os_day =
  //     dutyVal !== "Local"
  //       ? showNumber(t.trip_payouts_os_batta_total_amount)
  //       : 0;

  //   // Outstation Night Batta  ⭐ NEW
  //   let batta_os_night =
  //     dutyVal !== "Local"
  //       ? showNumber(t.trip_payouts_os_night_batta_total_amount)
  //       : 0;

  //   // Total batta for this duty
  //   let batta_main = batta_local + batta_os_day + batta_os_night;

  //   const extra_hour = showNumber(t.trip_payouts_extra_hour);
  //   const extra_hour_rate = showNumber(t.trip_payouts_slab_extra_hour_rate);
  //   const extra_km = showNumber(t.trip_payouts_extra_kms);
  //   const extra_km_rate = showNumber(t.trip_payouts_slab_extra_km_rate);

  //   // ---------------- DISPLAY FIELDS ----------------
  //   const displayExtraHours =
  //     dutyVal === "Outstation" || dutyVal === "OSDayRate"
  //       ? "-"
  //       : extra_hour > 0 && extra_hour_rate > 0
  //         ? `${extra_hour} × ${extra_hour_rate}`
  //         : "-";

  //   const displayExtraHoursAmt =
  //     dutyVal === "Outstation" || dutyVal === "OSDayRate"
  //       ? "-"
  //       : showAmount(t.trip_payouts_extra_hour_amount);

  //   const displayExtraKms =
  //     dutyVal === "Outstation" || dutyVal === "OSDayRate"
  //       ? "-"
  //       : extra_km > 0 && extra_km_rate > 0
  //         ? `${extra_km} × ${extra_km_rate}`
  //         : "-";

  //   const displayExtraKmsAmt =
  //     dutyVal === "Outstation" || dutyVal === "OSDayRate"
  //       ? "-"
  //       : showAmount(t.trip_payouts_extra_km_amount);

  //   // ---------------- PARKING / TOLL / PERMIT ----------------
  //   const parkingNum = showNumber(t.trip_payouts_parking);
  //   const tollNum = showNumber(t.trip_payouts_toll_fasttag);
  //   const permitNum = showNumber(t.trip_payouts_permit);
  //   const othersNum = showNumber(t.trip_payouts_others);

  //   // ---------------- RETURN FINAL ----------------
  //   return {

      
  //     serial: t.serial,

  //     duty: t.duty,
  //     tripsheet_number: t.tripsheet_number,
  //     // open_date: t.open_date
  //     //   ? new Date(t.open_date).toLocaleDateString("en-GB")
  //     //   : "-",

  //     open_date: t.open_date
  //       ? new Date(normalizeDateAny(t.open_date)).toLocaleDateString("en-GB")
  //       : "-",

  //     // vehicle_no: t.is_vendor_tripsheet ? t.vendor_vehicle_no : t.vehicleid,

  //     vehicle_no: t.is_vendor_tripsheet
  //       ? t.vendor_vehicle_no
  //       : t.vehicle_no || "-",

  //     vehicle_type: t.assigned_vehicle_group_name || "-",

  //     days: showDash(t.trip_payouts_days_used),
  //     hours: showDash(t.trip_payouts_hours_used),
  //     kms: showDash(t.trip_payouts_kms_used),

  //     slab_display: formatSlabDisplay(t),

  //     // NUMERIC VALUES (for totals)
  //     slab_rate: showNumber(
  //       dutyVal === "Outstation"
  //         ? t.trip_payouts_slab_os_rate
  //         : t.trip_payouts_slab_rate,
  //     ),

  //     slab_amount: showNumber(t.trip_payouts_charge_amount),
  //     extra_hour_amount: showNumber(t.trip_payouts_extra_hour_amount),
  //     extra_km_amount: showNumber(t.trip_payouts_extra_km_amount),

  //     // DISPLAY VALUES (for table)
  //     extra_hours_display: displayExtraHours,
  //     extra_hour_amount_display: displayExtraHoursAmt,

  //     extra_kms_display: displayExtraKms,
  //     extra_km_amount_display: displayExtraKmsAmt,

  //     batta_local: showNumber(batta_local),
  //     batta_os_day: showNumber(batta_os_day),
  //     batta_os_night: showNumber(batta_os_night),

  //     // This is what HTML uses as N.Batta
  //     nbatta: showNumber(batta_os_night),

  //     batta_main: showNumber(batta_main),

  //     parking: parkingNum,
  //     toll: tollNum,
  //     permit: permitNum,
  //     others: othersNum,

  //     escort_amount: showNumber(t.trip_payouts_escort_amount),

  //     advance:
  //       showNumber(t.trip_payouts_advance) +
  //       showNumber(t.trip_payouts_booking_advance),

  //     trip_net_amount:
  //       showNumber(t.trip_payouts_charge_amount) +
  //       showNumber(t.trip_payouts_extra_hour_amount) +
  //       showNumber(t.trip_payouts_extra_km_amount) +
  //       showNumber(batta_main) +
  //       parkingNum +
  //       tollNum +
  //       permitNum +
  //       othersNum +
  //       showNumber(t.trip_payouts_escort_amount),

  //     trip_advance:
  //       showNumber(t.trip_payouts_advance) +
  //       showNumber(t.trip_payouts_booking_advance),
  //   };
  // }

  function mapTripDuty(t) {

  // ============================================================
  // DEBUG - CHECK RAW TRIP DATA BEFORE MAPPING
  // ============================================================
  console.log("========== MAP TRIP DUTY DEBUG ==========");
  console.log("Tripsheet:", t.tripsheet_number || t.tripsheet_no);
  console.log("Basic Amount:", t.trip_payouts_basic_amount);
  console.log("Charge Amount:", t.trip_payouts_charge_amount);
  console.log("Full Trip Object:", t);
  console.log("==========================================");

  function showDash(val) {
    if (val === null || val === undefined) return "-";
    if (val === "") return "-";
    if (isNaN(val)) return "-";
    return Number(val);
  }

  function showNumber(val) {
    return val && !isNaN(val) ? Number(val) : 0;
  }

  function showAmount(val) {
    const num = Number(val);
    return num > 0 ? num : "-";
  }

  function formatSlabDisplay(item) {
    const itemDuty = (item.duty || "").trim();

    if (itemDuty === "Outstation" || itemDuty === "OSDayRate") {
      const days = showNumber(item.trip_payouts_days_used);
      const minKm = showNumber(item.trip_payouts_slab_km);
      return days > 0 && minKm > 0 ? `${days} / ${days * minKm}` : "-";
    }

    const hours = showNumber(item.trip_payouts_slab_hour);
    const kms = showNumber(item.trip_payouts_slab_km);
    return hours > 0 || kms > 0 ? `${hours} / ${kms}` : "-";
  }

  // ---------------- BATTA ----------------
  let dutyVal = (t.duty || "").trim();

  // Local batta
  let batta_local =
    dutyVal === "Local" ? showNumber(t.trip_payouts_local_batta) : 0;

  // Outstation Day Batta
  let batta_os_day =
    dutyVal !== "Local"
      ? showNumber(t.trip_payouts_os_batta_total_amount)
      : 0;

  // Outstation Night Batta
  let batta_os_night =
    dutyVal !== "Local"
      ? showNumber(t.trip_payouts_os_night_batta_total_amount)
      : 0;

  // Total batta for this duty
  let batta_main = batta_local + batta_os_day + batta_os_night;

  const extra_hour = showNumber(t.trip_payouts_extra_hour);
  const extra_hour_rate = showNumber(t.trip_payouts_slab_extra_hour_rate);
  const extra_km = showNumber(t.trip_payouts_extra_kms);
  const extra_km_rate = showNumber(t.trip_payouts_slab_extra_km_rate);

  // ---------------- DISPLAY FIELDS ----------------
  const displayExtraHours =
    dutyVal === "Outstation" || dutyVal === "OSDayRate"
      ? "-"
      : extra_hour > 0 && extra_hour_rate > 0
        ? `${extra_hour} × ${extra_hour_rate}`
        : "-";

  const displayExtraHoursAmt =
    dutyVal === "Outstation" || dutyVal === "OSDayRate"
      ? "-"
      : showAmount(t.trip_payouts_extra_hour_amount);

  const displayExtraKms =
    dutyVal === "Outstation" || dutyVal === "OSDayRate"
      ? "-"
      : extra_km > 0 && extra_km_rate > 0
        ? `${extra_km} × ${extra_km_rate}`
        : "-";

  const displayExtraKmsAmt =
    dutyVal === "Outstation" || dutyVal === "OSDayRate"
      ? "-"
      : showAmount(t.trip_payouts_extra_km_amount);

  // ---------------- PARKING / TOLL / PERMIT ----------------
  const parkingNum = showNumber(t.trip_payouts_parking);
  const tollNum = showNumber(t.trip_payouts_toll_fasttag);
  const permitNum = showNumber(t.trip_payouts_permit);
  const othersNum = showNumber(t.trip_payouts_others);

  // ---------------- RETURN FINAL ----------------
  return {
    serial: t.serial,

    duty: t.duty,
    tripsheet_number: t.tripsheet_number,

    open_date: t.open_date
      ? new Date(normalizeDateAny(t.open_date)).toLocaleDateString("en-GB")
      : "-",

    vehicle_no: t.is_vendor_tripsheet
      ? t.vendor_vehicle_no
      : t.vehicle_no || "-",

    vehicle_type: t.assigned_vehicle_group_name || "-",

    days: showDash(t.trip_payouts_days_used),
    hours: showDash(t.trip_payouts_hours_used),
    kms: showDash(t.trip_payouts_kms_used),

    slab_display: formatSlabDisplay(t),

    // NUMERIC VALUES (for totals)
    slab_rate: showNumber(
      dutyVal === "Outstation"
        ? t.trip_payouts_slab_os_rate
        : t.trip_payouts_slab_rate,
    ),

    slab_amount: showNumber(t.trip_payouts_basic_amount),
    extra_hour_amount: showNumber(t.trip_payouts_extra_hour_amount),
    extra_km_amount: showNumber(t.trip_payouts_extra_km_amount),

    // DISPLAY VALUES (for table)
    extra_hours_display: displayExtraHours,
    extra_hour_amount_display: displayExtraHoursAmt,

    extra_kms_display: displayExtraKms,
    extra_km_amount_display: displayExtraKmsAmt,

    batta_local: showNumber(batta_local),
    batta_os_day: showNumber(batta_os_day),
    batta_os_night: showNumber(batta_os_night),

    nbatta: showNumber(batta_os_night),

    batta_main: showNumber(batta_main),

    parking: parkingNum,
    toll: tollNum,
    permit: permitNum,
    others: othersNum,

    escort_amount: showNumber(t.trip_payouts_escort_amount),

    advance:
      showNumber(t.trip_payouts_advance) +
      showNumber(t.trip_payouts_booking_advance),

    trip_net_amount:
      showNumber(t.trip_payouts_basic_amount) +
      showNumber(t.trip_payouts_extra_hour_amount) +
      showNumber(t.trip_payouts_extra_km_amount) +
      showNumber(batta_main) +
      parkingNum +
      tollNum +
      permitNum +
      othersNum +
      showNumber(t.trip_payouts_escort_amount),

    trip_advance:
      showNumber(t.trip_payouts_advance) +
      showNumber(t.trip_payouts_booking_advance),
  };
}

  function mapBankDetails(clientBanks) {
    const bank = clientBanks.find((b) => b.is_primary) || clientBanks[0] || {};

    return {
      bank_name: bank.bank_name || "",
      account_number: bank.account_number || "",
      ifsc: bank.ifsc_code || "", // ✔ now correct
      branch: bank.branch || "",
      account_holder: bank.account_holder_name || "",
    };
  }

  const handlePreviewClose = () => {
    setShowPreview(false);

    // If user confirmed print earlier, now close the purchase also
    if (onSuccess) onSuccess();
  };

  const handleSave = async () => {
    try {
      if (!clientId) {
        setSnackbar({
          open: true,
          message: "Client ID missing",
          severity: "error",
        });
        return;
      }

      if (!form) {
        setSnackbar({
          open: true,
          message: "Form data missing",
          severity: "error",
        });
        return;
      }

      let purchaseNumber = form.number;

      // ================================
      // GENERATE NUMBER
      // ================================
      if (!form.purchaseid) {
        const createdDoc = await createDocument(
          clientId,
          "Purchase",
          "Purchase Document",
        );
        purchaseNumber = createdDoc.document_number;
      }

      const sanitize = (v) => (v === "" ? null : v);

      // ⭐ MODE FLAGS
      const isVendorPurchase = form.is_vendor_purchase === true;
      const isVehiclePurchase = form.is_vendor_purchase === false;

      // ================================
      // BUILD PURCHASE DATA
      // ================================
      const purchaseData = {
        ...form,

        client_id: clientId,
        fyid: 1,
        bill_type: "L",

        purchase_number: purchaseNumber,
        purchase_date: form.date
          ? new Date(form.date).toISOString().slice(0, 10)
          : null,

        // ⭐ IMPORTANT
        vendor_id: isVendorPurchase ? sanitize(form.vendorid) : null,
        vehicle_id: isVehiclePurchase ? form.vehicleid || null : null,
        is_vendor_purchase: isVendorPurchase ? 1 : 0,

        basic_amount,
        escort_amount,
        batta_amount,
        parking_amount,
        others_amount,
        permit_amount,
        toll_amount,
        fuel_esc_amount,
        net_amount: netAmount,

        voucher_ids: selectedVoucherIds || [],
        voucher_advance_amount: form.voucher_advance_amount || 0,
      };

      let purchaseid;

      // ================================
      // SAVE PURCHASE
      // ================================
      if (form.purchaseid) {
        await axiosInstance.put(
          `/api/purchases/${form.purchaseid}`,
          purchaseData,
          { params: { client_id: clientId } },
        );
        purchaseid = form.purchaseid;
      } else {
        const res = await axiosInstance.post("/api/purchases", purchaseData, {
          params: { client_id: clientId },
        });
        purchaseid = res.data.purchaseId || res.data.purchaseid;
        setForm((p) => ({ ...p, purchaseid }));
      }

      // ================================
      // LINK TRIP DUTIES
      // ================================
      const selectedDutyIds = (selectedIndex || [])
        .map((i) => rows[i]?.trip_duty_id)
        .filter((id) => Number.isInteger(id));

      if (selectedDutyIds.length > 0) {
        await axiosInstance.post("/api/purchases/trip-duties/update-purchase", {
          purchaseid,
          duty_trip_ids: selectedDutyIds,
        });
      }

      // ================================
      // LINK VOUCHERS
      // ================================
      if (Array.isArray(selectedVoucherIds) && selectedVoucherIds.length > 0) {
        await axiosInstance.post("/api/purchase/update-linked-vouchers", {
          purchase_id: purchaseid,
          voucher_ids: selectedVoucherIds.map(Number),

          // ⭐ ledger always vendor ledger
          vendor_id: isVendorPurchase ? form.vendorid : null,
          ledger_id: form.vendor_ledger_id || null,
        });
      }

      // ================================
      // LOAD TRIPS FOR PREVIEW
      // ================================
      let previewSelectedArray = [];

      try {
        const tripRes = await axiosInstance.get(
          `/api/purchases/${purchaseid}/tripduties`,
          {
            params: {
              client_id: clientId,
              filter_id: isVehiclePurchase ? form.vehicleid : form.vendorid,
            },
          },
        );

        const payload = tripRes.data;

        previewSelectedArray = payload?.selected || [];

        console.log("PREVIEW TRIPS RAW:", previewSelectedArray);
      } catch (err) {
        console.error("Preview trips load error:", err);
        previewSelectedArray = [];
      }

      const mappedTrips = previewSelectedArray.map((t, i) => {
        const m = mapTripDuty({ ...t, serial: i + 1 });

        return {
          serial: i + 1,

          duty: m.duty || m.duty_type || "",
          tripsheet_number: m.tripsheet_number || m.tripsheet_no || "",
          open_date:
            t.open_date ||
            t.trip_date ||
            t.duty_date ||
            t.date ||
            m.open_date ||
            m.trip_date ||
            m.duty_date ||
            m.date
              ? new Date(
                  t.open_date ||
                    t.trip_date ||
                    t.duty_date ||
                    t.date ||
                    m.open_date ||
                    m.trip_date ||
                    m.duty_date ||
                    m.date,
                ).toLocaleDateString("en-GB")
              : "",

          // ✅ FIXED LINE
          // vehicle_no: t.vehicle_no || m.vehicle_no || "",
          vehicle_no:
            t.vehicle_no ||
            t.vehicle_number ||
            m.vehicle_no ||
            m.vehicle_number ||
            "",

          vehicle_type: m.vehicle_type || m.type || "",

          days: m.days || m.total_days || 0,
          hours: m.hours || m.total_hours || 0,
          kms: m.kms || m.total_kms || 0,

          slab_display: m.slab_display || m.slab || "",
          slab_amount: Number(m.slab_amount || m.basic_amount || 0),

          extra_hours_display: m.extra_hours_display || m.extra_hours || 0,
          extra_hour_amount: Number(m.extra_hour_amount || 0),

          extra_kms_display: m.extra_kms_display || m.extra_kms || 0,
          extra_km_amount: Number(m.extra_km_amount || 0),

          batta_main: Number(m.batta_main || m.batta || 0),
          parking: Number(m.parking || 0),
          toll: Number(m.toll || 0),
          permit: Number(m.permit || 0),
          others: Number(m.others || 0),
          advance: Number(m.advance || 0),

          trip_net_amount: Number(m.trip_net_amount || m.net_amount || 0),
        };
      });

      // ================================
      // TOTALS
      // ================================
      let basicTotal = 0;
      let battaTotal = 0;
      let parkingTotal = 0;
      let tollTotal = 0;
      let permitTotal = 0;
      let othersTotal = 0;
      let extraHourTotal = 0;
      let extraKmTotal = 0;
      let netTotal = 0;

      let commissionTotal = 0;
      let tdsTotal = 0;
      let tripsheetAdvTotal = 0;
      let fuelIndentTotal = 0;
      let voucherTotal = 0;

      // ================================
      // CALCULATE FROM MAPPED TRIPS
      // ================================
      mappedTrips.forEach((t) => {
        basicTotal += Number(t.slab_amount || 0);

        extraHourTotal += Number(t.extra_hour_amount || 0);
        extraKmTotal += Number(t.extra_km_amount || 0);

        battaTotal += Number(t.batta_main || 0);
        parkingTotal += Number(t.parking || 0);
        tollTotal += Number(t.toll || 0);
        permitTotal += Number(t.permit || 0);
        othersTotal += Number(t.others || 0);

        netTotal += Number(t.trip_net_amount || 0);
      });

      // ================================
      // TOTAL EARNINGS
      // ================================
      const totalEarnings =
        basicTotal +
        // extraHourTotal +
        // extraKmTotal +
        battaTotal +
        parkingTotal +
        tollTotal +
        permitTotal +
        othersTotal;

      // ================================
      // TOTAL DEDUCTIONS
      // ================================
      const totalDeductions =
        commissionTotal +
        tdsTotal +
        tripsheetAdvTotal +
        fuelIndentTotal +
        voucherTotal;

      let vendorDetails = {};

      if (isVendorPurchase) {
        vendorDetails = vendors.find((v) => v.vendorid == form.vendorid) || {};
      } else {
        vendorDetails = {
          vendorname:
            form.vehicle_number ||
            mappedTrips?.[0]?.vehicle_no || // ✅ fallback from query
            "",
          vendorgstin: "",
        };
      }

      // ================================
      // BUILD PREVIEW OBJECT
      // ================================
      const previewObject = {
        client: clientDetails || {},
        vendor: {
          vendors: isVendorPurchase
            ? vendorDetails.vendorname || ""
            : form.vehicle_number ||
              mappedTrips?.[0]?.vehicle_no || // ✅ fallback
              "",

          vendorgstin: isVendorPurchase ? vendorDetails.vendorgstin || "" : "",
        },

        purchase: {
          number: purchaseNumber,
          date: purchaseData.purchase_date
            ? new Date(purchaseData.purchase_date).toLocaleDateString("en-GB")
            : "",

          period_from: form.period_from || "",
          period_to: form.period_to || "",
        },

        trips: mappedTrips,
        totals: {
          net: Number(netAmount || netTotal).toFixed(2),
          word_amount: numberToIndianWords(netAmount || netTotal),
        },

        totalsBreakup: {
          basic: basicTotal.toFixed(2),
          batta: battaTotal.toFixed(2),
          parking: parkingTotal.toFixed(2),
          toll: tollTotal.toFixed(2),
          permit: permitTotal.toFixed(2),
          others: othersTotal.toFixed(2),
          net: (netAmount || netTotal).toFixed(2),
        },

        terms: [],
        totalsSummary: {
          earnings: totalEarnings.toFixed(2),
          deductions: totalDeductions.toFixed(2),
        },
      };

      // ================================
      // PREVIEW API
      // ================================
      try {
        const previewRes = await axiosInstance.post(
          "/api/document-template/purchase/preview/compressed",
          previewObject,
        );

        setPreviewHTML(previewRes.data.html);
        setPreviewData(previewObject);
        setShowPreview(true);
      } catch {
        console.warn("Preview API failed – showing blank preview");
        setPreviewHTML("<h3>Preview Not Available</h3>");
        setPreviewData(previewObject);
        setShowPreview(true);
      }

      setSnackbar({
        open: true,
        message: "Purchase Saved Successfully",
        severity: "success",
      });
    } catch (err) {
      console.error("Unexpected error:", err);
      setSnackbar({
        open: true,
        message: "Unexpected error saving purchase",
        severity: "error",
      });
    }
  };

  const handleCancel = () => {
    if (onCancel) onCancel(); // Notify parent to hide the form
    // Optionally reset form state here if needed
  };

  const denseCellStyle = {
    border: "1px solid #ccc",
    px: 1, // Tight horizontal padding
    py: 0.5, // Tight vertical padding
    fontSize: 13,
    minWidth: 70,
  };

  const fontSizeUnified = 14; // Set your preferred font size here
  const fieldHeight = "30px";
  const fieldFontSize = fontSizeUnified;
  const columnWidths = {
    // label: 200,
    // inputLarge: 360,
    // inputMedium: 222,
    // inputSmall: 240,

    label: 400,
    inputLarge: 300,
    inputMedium: 400,
    inputSmall: 200,
  };

  const inputSx = {
    fontSize: fieldFontSize,
    height: fieldHeight,
    "& .MuiInputBase-input": {
      paddingTop: "0px",
      paddingBottom: "0px",
      fontSize: fieldFontSize,
      height: fieldHeight,
      lineHeight: fieldHeight,
      textAlign: "right",
    },
  };

  const inputtext = {
    fontSize: fieldFontSize,
    height: fieldHeight,
    "& .MuiInputBase-input": {
      paddingTop: "0px",
      paddingBottom: "0px",
      fontSize: fieldFontSize,
      height: fieldHeight,
      lineHeight: fieldHeight,
      textAlign: "left",
    },
  };

  const UniversalField = ({ label, value, sx = {}, ...rest }) => (
    <TextField
      size="small"
      label={label}
      value={value}
      sx={{
        ...inputSx,
        width: "100%",
        "& .MuiInputBase-root": {
          height: fieldHeight, // fixed height
          minHeight: fieldHeight,
        },
        "& .MuiInputBase-input": {
          height: fieldHeight,
          lineHeight: fieldHeight,
          fontSize: fieldFontSize,
          textAlign: "right", // 🔥 FORCE RIGHT ALIGN
        },
        ...sx, // external styles allowed
      }}
      InputProps={{ readOnly: true }}
      {...rest}
    />
  );

  const safeValue = (v) =>
    typeof v === "number"
      ? v.toFixed(2)
      : !isNaN(parseFloat(v))
        ? parseFloat(v).toFixed(2)
        : "0.00";

  console.log("PARENT vehicle_id:", form.vehicleid);

  return (
    <Box sx={{ maxWidth: 1300, mx: "auto", mt: 4, mb: 4, p: 2 }}>
      {/* Header fields */}
      <Typography
        sx={{ fontWeight: "bold", color: "#226ad3", mb: 2, fontSize: 17 }}
      >
        Purchase Details
      </Typography>
      <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
        {/* <TextField
          label="Client Place of Supply"
          value={form.client_place_of_supply}
          InputProps={{ readOnly: true }}
          size="small"
          variant="outlined"
          sx={{ mb: 1, minWidth: 240 }}
        /> */}

        <TextField
          size="small"
          variant="outlined"
          name="number"
          label="Purchase Number"
          value={form.number}
          onChange={handleFieldChange}
          sx={{ minWidth: 180, background: "#fcfcfc" }}
        />
        <MyDatePicker
          label="Purchase Date"
          value={form.date}
          onChange={(val) => {
            setForm((prev) => ({ ...prev, date: val }));
          }}
          placeholder="DD/MM/YYYY"
          containerStyle={{ marginBottom: 0 }}
          inputStyle={{ minWidth: 160, background: "#fcfcfc" }}
          labelStyle={{ fontSize: 12 }}
        />

        <TextField
          size="small"
          variant="outlined"
          name="reference"
          label="Reference"
          value={form.reference}
          onChange={handleFieldChange}
          sx={{ minWidth: 160, background: "#fcfcfc" }}
        />
        <TextField
          size="small"
          variant="outlined"
          name="po_no"
          label="P.O. Number"
          value={form.po_no}
          onChange={handleFieldChange}
          sx={{ minWidth: 160, background: "#fcfcfc" }}
        />
        <TextField
          select
          size="small"
          variant="outlined"
          name="payment_mode"
          label="Mode"
          value={form.payment_mode}
          onChange={handleFieldChange}
          sx={{ minWidth: 220, background: "#fcfcfc" }}
        >
          <MenuItem value="">Select</MenuItem>
          {paymentModes.map((payment_mode) => (
            <MenuItem key={payment_mode} value={payment_mode}>
              {payment_mode}
            </MenuItem>
          ))}
        </TextField>
      </Box>
      <Box sx={{ display: "flex", gap: 2, mb: 1 }}>
        <FormControl size="small" sx={{ width: 655 }}>
          {/* VENDOR OR VEHICLE */}
          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            {/* ============================= */}
            {/* VENDOR OR VEHICLE SELECTION */}
            {/* ============================= */}

            {isVendorMode && (
              <Box sx={{ width: 500 }}>
                <InputLabel shrink>Vendor</InputLabel>
                <VendorDropdown
                  clientId={clientId}
                  vendorId={form.vendorid ?? ""} // ✅ FIXED NAME
                  onVendorChange={(vendor) => {
                    if (!vendor) return;

                    setForm((prev) => ({
                      ...prev,
                      vendorid: vendor.vendor_id, // ✅ CONSISTENT FIELD
                      vehicle_id: null,
                      is_vendor_purchase: true,

                      gst_treatment: vendor.vendorgsttreament || "",
                      tax_preference: vendor.vendortaxpreference || "",
                      vendorgstin: vendor.vendorgstin || "",
                      place_of_supply: vendor.vendorplaceofsupply || "",

                      cal_gst_parking_toll_permit:
                        vendor.vendorapplygstparkingtollpermit || "",
                      cal_gst_batta: vendor.vendorapplygstbatta || "",
                      cal_gst_others: vendor.vendorapplygstothers || "",
                    }));
                  }}
                />
              </Box>
            )}

            {isVehicleMode && (
              <Box sx={{ width: 500 }}>
                <InputLabel shrink>Vehicle</InputLabel>

                <VehicleDropdown
                  clientId={clientId}
                  vehicleId={form.vehicleid ?? ""}
                  onVehicleChange={(vehicle) => {
                    if (!vehicle) return;

                    setForm((prev) => ({
                      ...prev,
                      vehicleid: vehicle.vehicle_id, // ✅ FIXED
                      vehicle_number: vehicle.vehicle_number,
                      vendorid: null,
                      is_vendor_purchase: false,

                      gst_treatment: vehicle.vehcile_gst_treatment || "",
                      tax_preference: vehicle.vehicle_tax_preference || "",
                      vendorgstin: vehicle.vehicle_gst_no || "",
                      place_of_supply: vehicle.vehile_place_of_supply || "",

                      cal_gst_parking_toll_permit:
                        vehicle.vehicle_gst_parking_toll_permit_flg
                          ? "Yes"
                          : "No",

                      cal_gst_batta: vehicle.vehicle_gst_batta_flg
                        ? "Yes"
                        : "No",

                      cal_gst_others: vehicle.vehicle_gst_others_flg
                        ? "Yes"
                        : "No",
                    }));
                  }}
                />
              </Box>
            )}
          </Box>
        </FormControl>
        <TextField
          size="small"
          variant="outlined"
          name="vendorgstin"
          label="GSTIN"
          value={form.vendorgstin || ""}
          InputProps={{ readOnly: true }}
          sx={{ minWidth: 160, background: "#fcfcfc", mr: 0 }}
        />
        <TextField
          size="small"
          variant="outlined"
          name="place_of_supply"
          label="Place of Supply"
          value={form.place_of_supply || ""}
          InputProps={{ readOnly: true }}
          sx={{ minWidth: 160, background: "#fcfcfc", mr: 0 }}
        />
      </Box>

      {/* filter section */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 4, mb: 0 }}>
        <Typography sx={{ fontWeight: "bold", fontSize: "0.875rem" }}>
          Filter By:
        </Typography>
        <RadioGroup row value={filterType} onChange={handleFilterChange}>
          <FormControlLabel
            value="all"
            control={<Radio size="small" />}
            label="All"
            sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.875rem" } }}
          />
          <FormControlLabel
            value="date"
            control={<Radio size="small" />}
            label="Date"
            sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.875rem" } }}
          />
        </RadioGroup>

        {filterType === "date" && (
          <Stack direction="row" spacing={2}>
            <MyDatePicker
              label="From"
              value={fromDate}
              onChange={(date) => setFromDate(date)}
              containerStyle={{ marginBottom: 0 }}
              inputStyle={{ minWidth: 140 }}
              labelStyle={{ fontSize: 12 }}
            />
            <MyDatePicker
              label="To"
              value={toDate}
              onChange={(date) => setToDate(date)}
              containerStyle={{ marginBottom: 0 }}
              inputStyle={{ minWidth: 140 }}
              labelStyle={{ fontSize: 12 }}
            />
          </Stack>
        )}
      </Box>

      {/* ----- Table Section ------- */}

      <Box
        sx={{
          mt: 1,
          border: "1px solid #ddd",
          overflowX: "auto",
          borderRadius: 1,
        }}
      >
        {isEditMode && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
            <Button
              variant="contained"
              size="small"
              onClick={handleAddDutyClick}
            >
              +Duty
            </Button>
          </Box>
        )}

        <Table
          size="small"
          stickyHeader
          sx={{ borderCollapse: "collapse", borderRadius: "8px" }}
        >
          <TableHead sx={{ backgroundColor: "#e0e3e4ff" }}>
            <TableRow
              sx={{
                "& th": {
                  backgroundColor: "#e0e3e4ff",
                  fontWeight: "bold",
                },
              }}
            >
              <TableCell
                padding="none"
                sx={{
                  ...denseCellStyle,
                  width: 36,
                  minWidth: 36,
                  maxWidth: 36,
                  p: 0,
                  m: 0,
                  textAlign: "center",
                }}
              >
                <Checkbox
                  size="small"
                  checked={selectedAll}
                  onChange={handleSelectAll}
                  sx={{ p: 0, m: 0 }}
                  inputProps={{ "aria-label": "select all rows" }}
                />
              </TableCell>

              <TableCell
                sx={{
                  ...denseCellStyle,
                  width: 100,
                  minWidth: 100,
                  maxWidth: 120,
                }}
              >
                TS No
              </TableCell>
              <TableCell
                sx={{
                  ...denseCellStyle,
                  width: 80,
                  minWidth: 80,
                  maxWidth: 90,
                }}
              >
                Open Date
              </TableCell>
              <TableCell sx={denseCellStyle}>Duty</TableCell>
              <TableCell sx={denseCellStyle}>Location</TableCell>
              <TableCell
                sx={{
                  ...denseCellStyle,
                  width: 110,
                  minWidth: 110,
                  maxWidth: 130,
                }}
              >
                Veh No,
              </TableCell>
              <TableCell
                sx={{
                  ...denseCellStyle,
                  width: 100,
                  minWidth: 100,
                  maxWidth: 130,
                }}
              >
                Veh Group
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  ...denseCellStyle,
                  width: 100,
                  minWidth: 100,
                  maxWidth: 130,
                }}
              >
                Basic
              </TableCell>
              <TableCell align="right" sx={denseCellStyle}>
                Fuel
              </TableCell>
              <TableCell align="right" sx={denseCellStyle}>
                Escort
              </TableCell>
              <TableCell align="right" sx={denseCellStyle}>
                Batta
              </TableCell>
              <TableCell align="right" sx={denseCellStyle}>
                Parking
              </TableCell>
              <TableCell align="right" sx={denseCellStyle}>
                Toll
              </TableCell>
              <TableCell align="right" sx={denseCellStyle}>
                Permit
              </TableCell>
              <TableCell align="right" sx={denseCellStyle}>
                Others
              </TableCell>
              <TableCell align="right" sx={denseCellStyle}>
                Advance
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row, idx) => (
              <TableRow
                key={`${row.trip_duty_id}-${idx}`}
                selected={selectedIndex.includes(idx)}
                hover
              >
                <TableCell
                  padding="none"
                  sx={{
                    border: "1px solid #ddd",
                    width: 36,
                    height: 36,
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  <Checkbox
                    size="small"
                    checked={selectedIndex.includes(idx)}
                    onChange={() => handleSelectRow(idx)}
                    sx={{ p: 0, m: 0 }}
                  />
                </TableCell>

                <TableCell sx={denseCellStyle}>
                  {row.tripsheet_number}
                </TableCell>

                <TableCell sx={{ ...denseCellStyle, width: 100, p: 1, pr: 1 }}>
                  <div
                    style={{
                      padding: 0,
                      margin: 0,
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {row.open_date
                      ? new Date(row.open_date).toLocaleDateString("en-GB")
                      : ""}
                  </div>
                </TableCell>

                <TableCell sx={denseCellStyle}>{row.duty}</TableCell>
                <TableCell sx={denseCellStyle}>{row.location}</TableCell>

                <TableCell
                  sx={{
                    ...denseCellStyle,
                    width: 120,
                    minWidth: 120,
                    maxWidth: 150,
                  }}
                >
                  {row.vehicle_no || row.vehicle_number || row.vehicleno || "-"}
                </TableCell>

                <TableCell
                  sx={{
                    ...denseCellStyle,
                    width: 100,
                    minWidth: 100,
                    maxWidth: 150,
                  }}
                >
                  {row.assigned_vehicle_group_name}
                </TableCell>

                {/* ===== AMOUNT COLUMNS (Supports RAW + MAPPED) ===== */}

                <TableCell sx={denseCellStyle} align="right">
                  {safeValue(row.trip_payouts_basic_amount ?? row.slab_amount)}
                </TableCell>

                <TableCell sx={denseCellStyle} align="right">
                  {safeValue(row.trip_payouts_fuel_esculation_amount ?? 0)}
                </TableCell>

                <TableCell sx={denseCellStyle} align="right">
                  {safeValue(
                    row.trip_payouts_escort_amount ?? row.escort_amount,
                  )}
                </TableCell>

                <TableCell sx={denseCellStyle} align="right">
                  {safeValue(row.trip_payouts_batta ?? row.batta_main)}
                </TableCell>

                <TableCell sx={denseCellStyle} align="right">
                  {safeValue(row.trip_payouts_parking ?? row.parking)}
                </TableCell>

                <TableCell sx={denseCellStyle} align="right">
                  {safeValue(row.trip_payouts_toll_fasttag ?? row.toll)}
                </TableCell>

                <TableCell sx={denseCellStyle} align="right">
                  {safeValue(row.trip_payouts_permit ?? 0)}
                </TableCell>

                <TableCell sx={denseCellStyle} align="right">
                  {safeValue(row.trip_payouts_others ?? row.others)}
                </TableCell>

                <TableCell sx={denseCellStyle} align="right">
                  {safeValue(row.trip_payouts_advance ?? row.advance)}
                </TableCell>
              </TableRow>
            ))}

            {/* Totals row */}
            <TableRow sx={{ backgroundColor: "#f3f6fb" }}>
              <TableCell colSpan={2} sx={{ border: "1px solid #bbb" }}>
                <Typography sx={{ color: "#009800", fontWeight: "bold" }}>
                  {selectedIndex.length} : Selected
                </Typography>
              </TableCell>

              <TableCell sx={{ border: "1px solid #bbb" }} />
              <TableCell sx={{ border: "1px solid #bbb" }} />
              <TableCell sx={{ border: "1px solid #bbb" }} />
              <TableCell sx={{ border: "1px solid #bbb" }} />
              <TableCell
                sx={{
                  border: "1px solid #bbb",
                  textAlign: "right",
                  fontWeight: "bold",
                }}
              >
                Totals:
              </TableCell>

              {/* TOTALS SUPPORT RAW + MAPPED */}
              {[
                { raw: "trip_payouts_basic_amount", map: "slab_amount" },
                { raw: "trip_payouts_fuel_esculation_amount", map: null },
                { raw: "trip_payouts_escort_amount", map: "escort_amount" },
                { raw: "trip_payouts_batta", map: "batta_main" },
                { raw: "trip_payouts_parking", map: "parking" },
                { raw: "trip_payouts_toll_fasttag", map: "toll" },
                { raw: "trip_payouts_permit", map: null },
                { raw: "trip_payouts_others", map: "others" },
                { raw: "trip_payouts_advance", map: "advance" },
              ].map((field, index) => (
                <TableCell
                  key={`${field.raw}-${index}`}
                  sx={{ border: "1px solid #bbb", fontWeight: "bold" }}
                  align="right"
                >
                  {safeValue(
                    rows.reduce(
                      (acc, r) =>
                        acc + (Number(r[field.raw] ?? r[field.map] ?? 0) || 0),
                      0,
                    ),
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </Box>

      {/* ===================== +Voucher Button (Top Right) ===================== */}
      {form.vendorid && (
        <Box sx={{ textAlign: "right", mt: 1 }}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleOpenVoucherTable}
            sx={{ fontWeight: "bold" }}
          >
            + Voucher
          </Button>
        </Box>
      )}

      {/* ===================== VOUCHER TABLE ===================== */}
      {showVoucherTable && (
        <Box
          sx={{
            mt: 2,
            border: "1px solid #d0d0d0",
            borderRadius: "6px",
            background: "#fff",
            p: 2,
            overflow: "visible !important",
          }}
        >
          {/* ---------- HEADER WITH +Voucher on Right ---------- */}

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: "16px",
                color: "#333",
              }}
            >
              Select Advance Vouchers
            </Typography>

            {/* ❌ Light simple close icon */}
            <CloseIcon
              onClick={() => setShowVoucherTable(false)}
              sx={{
                cursor: "pointer",
                color: "#999", // light grey
                fontSize: "22px",
                "&:hover": {
                  color: "#555", // slightly darker on hover
                },
              }}
            />
          </Box>

          <Table
            size="small"
            sx={{
              minWidth: 700,
              border: "1px solid #e0e0e0",
              "& th": {
                background: "#f5f5f5",
                fontWeight: "bold",
                fontSize: "14px",
                padding: "4px",
                borderRight: "1px solid #ddd",
              },
              "& td": {
                padding: "4px",
                fontSize: "14px",
                borderBottom: "1px solid #eee",
                borderRight: "1px solid #f0f0f0",
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  padding="none"
                  sx={{
                    border: "1px solid #ddd",
                    width: 36,
                    height: 36,
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  <Checkbox
                    checked={voucherSelectAll}
                    onChange={handleVoucherSelectAll}
                    sx={{
                      padding: "2px",
                      "& .MuiSvgIcon-root": {
                        fontSize: "20px",
                      },
                    }}
                  />
                </TableCell>

                <TableCell>Voucher No</TableCell>
                <TableCell>Voucher Date</TableCell>
                <TableCell>Narration</TableCell>
                <TableCell align="right">Advance Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vouchers.map((v) => {
                // FORCE numeric ID here (always a number)
                const vid = Number(v.voucher_id ?? v.id);

                return (
                  <TableRow
                    key={vid}
                    hover
                    selected={selectedVoucherIds.includes(vid)}
                    sx={{
                      cursor: "pointer",
                      "&.Mui-selected": {
                        backgroundColor: "#e8f4ff !important",
                      },
                    }}
                    onClick={(e) => {
                      // 👉 Prevent row click when checkbox is clicked
                      if (e.target.closest(".voucher-checkbox")) return;

                      handleVoucherSelect(vid);
                    }}
                  >
                    <TableCell
                      padding="none"
                      sx={{
                        border: "1px solid #ddd",
                        width: 36,
                        height: 36,
                        verticalAlign: "middle",
                        textAlign: "center",
                      }}
                    >
                      <Checkbox
                        className="voucher-checkbox" // ⭐ identifier to stop row click
                        checked={selectedVoucherIds.includes(vid)}
                        onChange={() => handleVoucherSelect(vid)} // ⭐ checkbox toggle
                        inputProps={{ "aria-label": `select-voucher-${vid}` }}
                        sx={{
                          padding: "2px",
                          "& .MuiSvgIcon-root": { fontSize: "20px" },
                        }}
                      />
                    </TableCell>

                    <TableCell>{v.voucher_number}</TableCell>
                    <TableCell>
                      {new Date(v.voucher_date).toLocaleDateString("en-GB")}
                    </TableCell>
                    <TableCell>{v.narration}</TableCell>
                    <TableCell align="right">
                      {Number(v.credit_amount || 0).toFixed(2)}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Box>
      )}

      {/* ------------Summary----------------- */}
      <Box
        sx={{
          mt: 2,
          mb: 2,
          px: 3,
          py: 2,
          maxWidth: 1260,
          background: "#fff",
          borderRadius: 3,
          boxShadow: 2,
        }}
      >
        {/* Top row */}
        <Stack direction="row" alignItems="center" spacing={0} mb={1}>
          <Box sx={{ width: columnWidths.inputLarge, mr: 2 }}>
            <UniversalField
              label="GST Treatment"
              value={form.gst_treatment}
              sx={{ ...inputtext, width: "100%" }}
            />
          </Box>
          <Box sx={{ width: columnWidths.inputSmall }}>
            <UniversalField
              label="Tax Preference"
              value={form.tax_preference}
              sx={{ ...inputtext, width: "100%" }}
            />
          </Box>
          <Box sx={{ width: columnWidths.inputSmall, ml: 2 }}>
            <UniversalField
              label="HSN Code"
              value={hsn_code}
              sx={{ ...inputtext, width: "100%" }}
            />
          </Box>
          <Box sx={{ width: columnWidths.inputSmall, ml: 2 }} />
        </Stack>

        {/* Charges rows */}
        <Stack spacing={0.25}>
          {[
            { label: "Basic Amount", value: basic_amount },
            { label: "Fuel Escalation", value: fuel_esc_amount },
            { label: "Escort", value: escort_amount },
            { label: "Batta", value: batta_amount, gstField: "cal_gst_batta" },
            {
              label: "Parking",
              value: parking_amount,
              gstField: "cal_gst_parking_toll_permit",
            },
            {
              label: "Toll",
              value: toll_amount,
              gstField: "cal_gst_parking_toll_permit",
            },
            {
              label: "Permit",
              value: permit_amount,
              gstField: "cal_gst_parking_toll_permit",
            },
            {
              label: "Others",
              value: others_amount,
              gstField: "cal_gst_others",
            },
          ].map(({ label, value, gstField }) => (
            <Stack direction="row" alignItems="center" spacing={0} key={label}>
              <Box sx={{ width: columnWidths.label }}>
                <Typography sx={{ fontSize: fieldFontSize }}>
                  {label}
                </Typography>
              </Box>
              <Box sx={{ width: columnWidths.inputLarge }} />
              <Box
                sx={{
                  width: columnWidths.inputMedium,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                {gstField ? (
                  <TextField
                    size="small"
                    variant="outlined"
                    value={form[gstField] || ""}
                    placeholder="Yes / No"
                    InputProps={{ readOnly: true }}
                    sx={{
                      width: 100,
                      mr: 4,
                      "& .MuiInputBase-root": {
                        height: "28px",
                        minHeight: "28px",
                      },
                      "& .MuiInputBase-input": {
                        textAlign: "center",
                        fontSize: fieldFontSize - 2,
                        padding: "0 4px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#bbb",
                      },
                    }}
                    InputLabelProps={{ shrink: false }}
                    inputProps={{ style: { textAlign: "center" } }}
                  />
                ) : null}
              </Box>
              <Box sx={{ width: columnWidths.inputSmall }}>
                <UniversalField value={safeValue(value)} />
              </Box>
            </Stack>
          ))}
        </Stack>

        {/* Any Addition Charges */}
        <Stack
          direction="row"
          alignItems="center"
          spacing={0}
          sx={{ mt: 0.25 }}
        >
          <Box sx={{ width: columnWidths.label }}>
            <Typography sx={{ fontSize: fieldFontSize }}>
              Any Addition Charges
            </Typography>
          </Box>
          <Box sx={{ width: columnWidths.inputLarge }}>
            <TextField
              size="small"
              sx={{
                ...inputSx,
                width: "100%",
                "& .MuiInputBase-root": {
                  height: fieldHeight,
                  minHeight: fieldHeight,
                },
                "& .MuiOutlinedInput-root": {
                  padding: 0,
                  minHeight: fieldHeight,
                },
                "& .MuiInputBase-input": {
                  textAlign: "left",
                  height: fieldHeight,
                  padding: "0 8px",
                },
              }}
              placeholder="Addition Remarks"
              value={form.addition_remarks || ""}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  addition_remarks: e.target.value,
                }))
              }
              inputProps={{ style: { fontSize: fieldFontSize } }}
            />
          </Box>
          <Box sx={{ width: columnWidths.inputMedium }} />
          <Box sx={{ width: columnWidths.inputSmall }}>
            <TextField
              size="small"
              sx={{
                ...inputSx,
                width: "100%",
                "& .MuiInputBase-root": {
                  height: fieldHeight,
                  minHeight: fieldHeight,
                },
                "& .MuiInputBase-input": {
                  textAlign: "right",
                  fontSize: fieldFontSize,
                  MozAppearance: "textfield",
                  "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                },
              }}
              type="number"
              step="0.01"
              value={
                form.addition_amount != null
                  ? (Number(form.addition_amount) || 0).toFixed(2)
                  : "0.00"
              }
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  addition_amount: parseFloat(e.target.value) || 0,
                }))
              }
              inputProps={{ style: { fontSize: fieldFontSize } }}
            />
          </Box>
        </Stack>

        {/* Discount (on Basic Amount) */}
        <Stack
          direction="row"
          alignItems="center"
          spacing={0}
          sx={{ mt: 0.25 }}
        >
          <Box sx={{ width: columnWidths.label }}>
            <Typography sx={{ fontSize: fieldFontSize }}>
              Discount (on Basic Amount)
            </Typography>
          </Box>
          <Box sx={{ width: columnWidths.inputLarge }}>
            <TextField
              size="small"
              sx={{
                ...inputSx,
                width: 185,
                "& .MuiInputBase-root": { height: "30px", minHeight: "30px" },
                "& .MuiInputBase-input": {
                  ...inputSx["& .MuiInputBase-input"],
                  textAlign: "right",
                },
              }}
              type="number"
              value={form.discount_percent || 0}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  discount_percent: Number(e.target.value) || 0,
                }))
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Typography
                      sx={{ fontWeight: "bold", fontSize: fieldFontSize }}
                    >
                      %
                    </Typography>
                  </InputAdornment>
                ),
              }}
              inputProps={{
                style: {
                  fontSize: fieldFontSize,
                  height: "30px",
                  textAlign: "right",
                },
              }}
            />
          </Box>
          <Box sx={{ width: columnWidths.inputMedium }} />
          <Box sx={{ width: columnWidths.inputSmall }}>
            <UniversalField
              value={
                form.discount_amount != null
                  ? (Number(form.discount_amount) || 0).toFixed(2)
                  : "0.00"
              }
            />
          </Box>
        </Stack>

        {/* Any Deduction */}
        <Stack
          direction="row"
          alignItems="center"
          spacing={0}
          sx={{ mt: 0.25 }}
        >
          <Box sx={{ width: columnWidths.label }}>
            <Typography sx={{ fontSize: fieldFontSize }}>
              Any Deduction
            </Typography>
          </Box>
          <Box sx={{ width: columnWidths.inputLarge }}>
            <TextField
              size="small"
              sx={{
                ...inputSx,
                width: "100%",
                "& .MuiInputBase-root": { height: "30px", minHeight: "30px" },
                "& .MuiOutlinedInput-root": { minHeight: "30px", padding: 0 },
                "& .MuiInputBase-input": {
                  fontSize: fieldFontSize,
                  height: "30px",
                  lineHeight: "30px",
                  padding: "0 8px",
                  textAlign: "left",
                },
              }}
              placeholder="Deduction Remarks"
              value={form.deduction_remarks || ""}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  deduction_remarks: e.target.value,
                }))
              }
              inputProps={{
                style: { fontSize: fieldFontSize, textAlign: "left" },
              }}
            />
          </Box>
          <Box sx={{ width: columnWidths.inputMedium }} />
          <Box sx={{ width: columnWidths.inputSmall }}>
            <TextField
              size="small"
              sx={{
                ...inputSx,
                width: "100%",
                "& .MuiInputBase-root": { height: "30px", minHeight: "30px" },
                "& .MuiInputBase-input": {
                  fontSize: fieldFontSize,
                  height: "30px",
                  lineHeight: "30px",
                  padding: "0 12px 0 0",
                  textAlign: "right",
                  MozAppearance: "textfield",
                  "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                },
              }}
              type="number"
              step="0.01"
              value={Number(form.deduction_amount).toFixed(2)}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  deduction_amount: parseFloat(e.target.value) || 0,
                }))
              }
              inputProps={{
                style: {
                  fontSize: fieldFontSize,
                  textAlign: "right",
                  height: "30px",
                  lineHeight: "30px",
                  padding: "0 12px 0 0",
                },
              }}
            />
          </Box>
        </Stack>

        {/* Amount before tax (Gross) */}
        <Stack
          direction="row"
          alignItems="center"
          spacing={0}
          sx={{ mt: 0.25 }}
        >
          <Box sx={{ width: columnWidths.label }}>
            <Typography sx={{ fontWeight: "bold", fontSize: fieldFontSize }}>
              {form.tax_preference === "Taxable"
                ? "Amount before tax (Gross)"
                : "Gross Amount"}
            </Typography>
          </Box>
          <Box sx={{ width: columnWidths.inputLarge }} />
          <Box sx={{ width: columnWidths.inputMedium }} />
          <Box sx={{ width: columnWidths.inputSmall }}>
            <TextField
              size="small"
              sx={{ ...inputSx, width: "100%", background: "#d3f5d7" }}
              value={
                form.gross_before_tax
                  ? form.gross_before_tax.toFixed(2)
                  : "0.00"
              }
              inputProps={{
                readOnly: true,
                style: {
                  fontSize: fieldFontSize,
                  height: fieldHeight,
                  textAlign: "right",
                },
              }}
            />
          </Box>
        </Stack>

        {/* Taxable Amount */}
        {form.tax_preference === "Taxable" && (
          <Stack
            direction="row"
            alignItems="center"
            spacing={0}
            sx={{ mt: 0.25 }}
          >
            <Box sx={{ width: columnWidths.label }}>
              <Typography sx={{ fontSize: fieldFontSize }}>
                Taxable Amount
              </Typography>
            </Box>
            <Box sx={{ width: columnWidths.inputSmall }}>
              <TextField
                size="small"
                sx={{ ...inputSx, width: "100%" }}
                value={
                  form.taxable_amount ? form.taxable_amount.toFixed(2) : "0.00"
                }
                inputProps={{
                  readOnly: true,
                  style: {
                    fontSize: fieldFontSize,
                    height: fieldHeight,
                    textAlign: "right",
                  },
                }}
              />
            </Box>
            <Box sx={{ width: columnWidths.inputLarge }} />
            <Box sx={{ width: columnWidths.inputMedium }} />
          </Stack>
        )}

        {/* GST Rows */}
        {form.tax_preference === "Taxable" &&
          (() => {
            const isRCM =
              form.gst_treatment === "Registered Business-Under RCM";

            const gstRows =
              form.place_of_supply === form.client_place_of_supply
                ? [
                    {
                      type: "CGST",
                      percent: form.cgst_percent,
                      amount: form.cgst_amount,
                    },
                    {
                      type: "SGST",
                      percent: form.sgst_percent,
                      amount: form.sgst_amount,
                    },
                  ]
                : [
                    {
                      type: "IGST",
                      percent: form.igst_percent,
                      amount: form.igst_amount,
                    },
                  ];

            return gstRows.map(({ type, percent, amount }) => (
              <Stack
                direction="row"
                alignItems="center"
                spacing={0}
                key={type}
                sx={{ mt: 0.25 }}
              >
                {/* LABEL */}
                <Box sx={{ width: columnWidths.label }}>
                  <Typography
                    sx={{
                      fontSize: fieldFontSize,
                      color: isRCM ? "red" : "inherit",
                    }}
                  >
                    {type}
                  </Typography>
                </Box>

                {/* PERCENT INPUT */}
                <Box sx={{ width: columnWidths.inputLarge }}>
                  <TextField
                    size="small"
                    name={
                      type === "CGST"
                        ? "cgst_percent"
                        : type === "SGST"
                          ? "sgst_percent"
                          : "igst_percent"
                    }
                    value={percent ?? ""}
                    onChange={handleFieldChange}
                    sx={{
                      ...inputSx,
                      width: 185,
                    }}
                    InputProps={{
                      sx: {
                        "& .MuiInputBase-input": {
                          color: isRCM ? "red" : "inherit",
                          textAlign: "right",
                        },
                      },
                      endAdornment: (
                        <Typography
                          sx={{
                            color: isRCM ? "red" : "text.secondary",
                            fontSize: fieldFontSize,
                            pr: 1,
                          }}
                        >
                          %
                        </Typography>
                      ),
                    }}
                  />
                </Box>

                {/* EMPTY MIDDLE */}
                <Box sx={{ width: columnWidths.inputMedium }} />

                {/* AMOUNT */}
                <Box sx={{ width: columnWidths.inputSmall }}>
                  <UniversalField
                    value={amount != null ? amount.toFixed(2) : "0.00"}
                    sx={{
                      "& .MuiInputBase-input": {
                        color: isRCM ? "red" : "inherit",
                        textAlign: isRCM ? "left" : "right",
                      },
                    }}
                  />
                </Box>
              </Stack>
            ));
          })()}

        {/* Advance and other amount rows */}
        <Stack spacing={0.25} sx={{ mt: 0.25 }}>
          {[
            { label: "Advance in Tripsheet", value: form.advance_amount },
            {
              label: "Advance in Receipts (On Account)",
              value: form.voucher_advance_amount,
            },
            { label: "Coin Adjust", value: form.coin_adjust },
            { label: "Net Amount", value: netAmount, highlight: true },
          ].map(({ label, value, highlight }) => (
            <Stack direction="row" alignItems="center" spacing={0} key={label}>
              <Box sx={{ width: columnWidths.label }}>
                <Typography
                  sx={{
                    fontSize: fieldFontSize,
                    fontWeight: highlight ? "bold" : "normal",
                  }}
                >
                  {label}
                </Typography>
              </Box>
              <Box sx={{ width: columnWidths.inputLarge }} />
              <Box sx={{ width: columnWidths.inputMedium }} />
              <Box sx={{ width: columnWidths.inputSmall }}>
                <TextField
                  size="small"
                  sx={{
                    ...inputSx,
                    width: "100%",
                    background: highlight ? "#d3f5d7" : undefined,
                  }}
                  value={value != null ? value.toFixed(2) : "0.00"}
                  inputProps={{
                    style: {
                      fontSize: fieldFontSize,
                      height: fieldHeight,
                      textAlign: "right",
                      fontWeight: highlight ? "bold" : "normal",
                    },
                    readOnly: true,
                  }}
                />
              </Box>
            </Stack>
          ))}
        </Stack>

        {/* Bottom Remarks */}
        <Stack direction="row" spacing={2} mt={1.5}>
          <TextField
            fullWidth
            size="small"
            multiline
            minRows={2}
            maxRows={2}
            label="GST Notification"
            name="gst_notification"
            value={form.gst_notification || ""}
            onChange={handleFieldChange}
            sx={{
              minWidth: 220,
              "& .MuiInputBase-input": {
                textAlign: "left",
                padding: "6px 8px",
                fontSize: "12px",
                lineHeight: "16px",
              },
              "& .MuiInputLabel-root": {
                fontSize: "12px",
              },
              "& textarea": {
                textAlign: "left !important",
              },
            }}
          />

          <TextField
            fullWidth
            size="small"
            label="Remarks"
            name="remarks"
            multiline
            minRows={2}
            maxRows={2}
            value={form.remarks || ""}
            onChange={handleFieldChange}
            sx={{
              minWidth: 220,
              "& .MuiInputBase-input": {
                textAlign: "left",
                padding: "6px 8px",
                fontSize: "12px",
                lineHeight: "16px",
              },
              "& .MuiInputLabel-root": {
                fontSize: "12px",
              },
              "& textarea": {
                textAlign: "left !important",
              },
            }}
          />
        </Stack>
      </Box>

      <Box
        sx={{ display: "flex", justifyContent: "flex-start", mt: 3, gap: 2 }}
      >
        <Button variant="contained" color="primary" onClick={handleSave}>
          {form.purchaseid && form.purchaseid !== "new" ? "Update" : "Save"}
        </Button>
        <Button variant="outlined" color="secondary" onClick={handleCancel}>
          Cancel
        </Button>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>

      {showPreview && previewHTML && (
        <PreviewModal
          open={showPreview}
          onClose={() => handlePreviewClose()}
          html={previewHTML}
          invoiceData={previewData} // ✅ CHANGE HERE
          mode="compressed"
          templateType="purchase" // MUST BE HERE
          showSnackbar={(snack) =>
            setSnackbar({
              open: true,
              message: snack.message,
              severity: snack.severity,
            })
          }
        />
      )}
    </Box>
  );
}
